import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-our-story',
  templateUrl: './our-story.component.html',
  styleUrls: ['./our-story.component.scss']
})
export class OurStoryComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }


}
